export interface EnvSettings extends Window {
  HOSTNAME_API: string;
  FRONT_PAGE_CITIZEN: string;
  FRONT_PAGE_CASEWORKER: string;

  EDP_SERV: string;
  FILTER_SERV: string;
  LOGGER_SERV: string;
  UTILS_SERV: string;
  PAYMENT_SERV: string;

  PROPERTY_PREF: string;
  LOG_PREF: string;
  LEGAL_CONSENTS_PREF: string;
  REGISTER_CONSENT_PREF: string;
  CREATE_LOAN_APP_PREF: string;
  TRANSACTIONID_PREF: string;
  GET_LOANS_PREF: string;
  GET_INTEREST_CALCULATION_PREF: string;
  SERVER_DATETIME_PREF: string;
  INITIALIZE_TOKEN_PREF: string;
  JWT: string;
  REFRESH_TOKEN: string;
  LOG_OUT_IDENT: string;
  CREATE_SINGLE_PREF: string;
  REGISTER_PAYMENT_PREF: string;

  UTILS_API_URL: string;
  EDP_API_URL: string;
  FILTER_API_URL: string;
  LOG_API_URL: string;
  PAYMENT_API_URL: string;

  SEND_LOGS: boolean;
  LOGS_STACKTRACE_DEPTH: number;

  MODULE_ID_CLS_LOG: string;
  MODULE_NAME_CLS_LOG: string;
  AFTALEID_CLS_LOG: string;
  REQUESTID_CLS_LOG: string;

  RETURN_COMPANIES: boolean;

  LOAN_TYPE_ID_TEMP: string;

  INTEREST_CALCULATION: boolean;

  ASSESSMENT_PORT_PENSIONER_LOAN_EXT: string;
  TSB_EXT: string;
  PRIVACY_POLICY_COOKIES_EXT: string;
  LOG_OFF_EXT: string;
  AVAILABILITY_STATEMENT_EXT: string;
  CONSENT_RATE_EXT: string;
  TAX_FREEZE_LOAN_INTEREST_RATE_EXT: string;
  APPLICALE_LAWS_EXT: string;
  REGULATIONS_EXT: string;
  PROPERTY_VALUATION_LAW_EXT: string;
  DATA_PROTECTION_LAW_EXT: string;
  EACT_APP_ANNOUCEMENT_ARCHIVES_ACT_EXT: string;
  LOV_503_EXT: string;
  LOV_1943_EXT: string;
  EU_LEGISLATION_EXT: string;
  LEGAL_INFORMATION_EXT: string;
  DATA_PROTECTION_AUTHORITY_EXT: string;
  MAILTO_DPO_UFST_EXT: string;
  MAILTO_VURDST_EXT: string;
  ANNOUCEMENT_ARCHIVES_ACT_EXT: string;
  CONTACT_ASSESSMENT_AGENCY: string;
  INTEREST_RATE: string;
}

const envSettings = window as unknown as EnvSettings;
export default envSettings;
